import {Util} from 'yougile-util'
import {toCyrillic, toCyrillicKeyboard} from './to-cyrillic'
import {toLatin, toLatinKeyboard} from './to-latin'

export const getVariationMentionText = (
  mentionText?: string
): string[] | undefined => {
  if (!mentionText) {
    return undefined
  }

  const cyrillicKeyboard = toCyrillicKeyboard(mentionText)
  const latinKeyboard = toLatinKeyboard(mentionText)

  let variations = [
    mentionText,
    toCyrillic(mentionText),
    ...toLatin(mentionText),

    cyrillicKeyboard,
    ...toLatin(cyrillicKeyboard),

    latinKeyboard,
    toCyrillic(latinKeyboard)
  ]

  variations = variations.map(v => v?.toLowerCase())

  return Util.removeDuplicates(variations)
}
